import React, { useState, useEffect } from 'react';
import './PlayerNotesCrud.css';
import { Button } from "@material-ui/core";
import axios from "axios";
import { toast } from 'react-toastify';

const PlayerNotesCrud = (props) => {

    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(false); // false for 'Normal', true for 'Permanent'
    const [useExpirationDate, setUseExpirationDate] = useState(false);
    const [expirationDate, setExpirationDate] = useState(null);
    const [useDisplayCounter, setUseDisplayCounter] = useState(false);
    const [displayCounter, setDisplayCounter] = useState(0);
    const [useCloseOption, setUseCloseOption] = useState(false);

    // Pre-cargar los valores si se está editando un mensaje
    useEffect(() => {

        if (props.edit && props.Message) {
            console.log('props===>', props)
            setMessage(props.Message.message);
            setMessageType(props.Message.messageType);
            setUseExpirationDate(props.Message.useExpirationDate);
            setExpirationDate(props.Message.expirationDate);
            setUseDisplayCounter(props.Message.useDisplayCounter);
            setDisplayCounter(props.Message.displayCounter);
            setUseCloseOption(props.Message.useCloseOption);
        }
        console.log(props)
    }, [props.edit, props.Message]);

    const closeModal = () => {
        props.handleClose();
    }

    function PlayerMessagesInsert() {
        let request = [{
            IdPlayer: props.idPlayer,
            Message: message,
            MessageType: messageType,
            UseExpirationDate: useExpirationDate,
            ExpirationDate: useExpirationDate ? expirationDate : new Date(),
            UseDisplayCounter: useDisplayCounter,
            DisplayCounter: useDisplayCounter ? displayCounter : 0,
            UseCloseOption: useCloseOption,
            IdUser: props.userInfo.userId,
        }];

        axios({
            method: "post",
            url: process.env.REACT_APP_API2_URL + "/Player/PlayerMessages_Insert",
            data: request,
        }).then((response) => {
            console.log("response", response);
            toast.success(`Message created successfully`);
            props.msgSuccess();
            closeModal(); // Cierra el modal después de la inserción exitosa
        });
    }

    function PlayerMessageEdit() {
        let request = {
            prmIdPlayer: props.idPlayer,
            prmMessage: message,
            prmMessageType: messageType,
            prmUseExpirationDate: useExpirationDate,
            prmExpirationDate: useExpirationDate ? expirationDate : new Date(),
            prmUseDisplayCounter: useDisplayCounter,
            prmDisplayCounter: useDisplayCounter ? displayCounter : 0,
            prmUseCloseOption: useCloseOption,
            prmIdUser: props.userInfo.userId,
            prmIdPlayerMessage: props.Message.idPlayerMessage  // Necesario para editar el mensaje existente
        };

        axios({
            method: "post",
            url: process.env.REACT_APP_API2_URL + "/Player/PlayerMessages_Update",
            data: request,
        }).then((response) => {
            console.log("response", response);
            if (response.data === 0) {
                toast.success(`Message updated successfully`);
            } else {
                toast.error(`An error has occurred. Please try again`);
            }
            props.msgSuccess();
            closeModal(); // Cierra el modal después de la edición exitosa
        });
    }

    return (
        <div className="online-message-settings">
            <div>
                <textarea
                    placeholder="Message Settings"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                ></textarea>
            </div>

            <div className="message-options">
                <div className="left-column">
                    <label>
                        <input
                            type="radio"
                            name="messageType"
                            checked={messageType === false}
                            onChange={() => setMessageType(false)}
                        />
                        Normal
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            checked={useExpirationDate}
                            onChange={(e) => setUseExpirationDate(e.target.checked)}
                        />
                        Expiration Date
                        {useExpirationDate && (
                            <input
                                type="date"
                                value={expirationDate || ''}
                                onChange={(e) => setExpirationDate(e.target.value)}
                            />
                        )}
                    </label>
                </div>

                <div className="right-column">
                    <label>
                        <input
                            type="radio"
                            name="messageType"
                            checked={messageType === true}
                            onChange={() => setMessageType(true)}
                        />
                        Permanent
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            checked={useDisplayCounter}
                            onChange={(e) => setUseDisplayCounter(e.target.checked)}
                        />
                        Display Counter
                        {useDisplayCounter && (
                            <input
                                type="number"
                                value={displayCounter}
                                onChange={(e) => setDisplayCounter(e.target.value)}
                            />
                        )}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            checked={useCloseOption}
                            onChange={(e) => setUseCloseOption(e.target.checked)}
                        />
                        Player can disable message
                    </label>
                </div>
            </div>

            <div className="message-actions">
                <Button
                    onClick={props.edit === false ? PlayerMessagesInsert : PlayerMessageEdit}
                    color="primary"
                    variant="contained">
                    {props.edit === false ? 'Save Message' : 'Save Message'}
                </Button>
                <Button
                    // Clear message logic can be added here
                    color="primary"
                    variant="contained">
                    Clear Message
                </Button>
                <Button
                    onClick={() => closeModal()}
                    color="secondary"
                    variant="contained"
                    autoFocus
                >
                    Close
                </Button>

            </div>
        </div>
    );
};

export default PlayerNotesCrud;